import * as React from "react";
import { Formik, Form, Field } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Row, Col, Input } from "components/bootstrap";
import { FormSubmit } from "components/common";
import Team from "../../logic/Team";
const Container = styled.div`
  padding: 15px;
`;
const TeamQuickCreate = ({ onClose, onSubmit }) => {
  const { t } = useTranslation("enterprise_security");
  const _onSubmit = ({ name, description }, { resetForm }) => {
    const newTeam = Team.builder().name(name).description(description).build();
    return onSubmit(newTeam).then(() => {
      resetForm();
      onClose();
    });
  };
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Formik, { onSubmit: _onSubmit, initialValues: { name: "", description: "" } }, ({ isSubmitting, isValid }) => /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(Field, { name: "name" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "name",
      label: t("team_quick_create.name_label"),
      required: true,
      maxLength: 200,
      onChange,
      help: t("team_quick_create.name_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      value
    }
  )), /* @__PURE__ */ React.createElement(Field, { name: "description" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "description",
      label: t("team_quick_create.description_label"),
      required: true,
      onChange,
      help: t("team_quick_create.description_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      value
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 9, xsOffset: 3 }, /* @__PURE__ */ React.createElement(
    FormSubmit,
    {
      isSubmitting,
      isAsyncSubmit: true,
      onCancel: onClose,
      disabledSubmit: !isValid,
      submitButtonText: t("team_quick_create.submit"),
      submitLoadingText: t("team_quick_create.submitting")
    }
  ))))));
};
export default TeamQuickCreate;
